export const formatDate = function(date) {

  var day = date.getDate();
  var month = date.getMonth()+1;
  var year = date.getFullYear();

  return year + '-' + month + '-' + ('0' + day).slice(-2);
}

export const getFirstDayOfMonth = function(month,year){
  return formatDate(new Date(year,month-1,1))
}

export const getLastDayOfMonth = function(month,year){
  return formatDate(new Date(year,month,0))
}

export const monthList = function(){
  let list = []
  let i

  for (i=1;i<=12;i++)
    list.push(i)

  return list 
}

export const yearList = function(){
  let list = []
  let i

  for (i=2014; i <= new Date().getFullYear() ; i++)
    list.push(i)

  return list 
}